/*
 * Adapted from money.js by JO on 29.4.2022
 * http://openexchangerates.github.io/money.js/
 */

import { NumberHash } from '@upright/common/utils/number-hash/types';
import { exchangeRates2019 } from './exchange-rates-2019';
import { exchangeRates2022 } from './exchange-rates-2022';

function getYearRates(year: number): { base: string; rates: NumberHash } {
  switch (year) {
    case 2019:
      return { base: exchangeRates2019.base, rates: exchangeRates2019.rates };
    case 2022:
      return { base: exchangeRates2022.base, rates: exchangeRates2022.rates };
    default:
      throw Error('Unsupported year');
  }
}

// The base function of the library: converts a value from one currency to another
export function moneyJsConvert(from: string, to: string, value: number, year: number) {
  return value * getRate(to, from, year);
}

// Returns the exchange rate to `target` currency from `base` currency
function getRate(to: string, from: string, year: number) {
  const { base, rates } = getYearRates(year);

  // Make sure the base rate is in the rates object:
  rates[base] = 1;

  // Throw an error if either rate isn't in the rates array
  if (!rates[to] || !rates[from]) {
    throw Error('fx error');
  }

  // If `from` currency === fx.base, return the basic exchange rate for the `to` currency
  if (from === base) {
    return rates[to];
  }

  // If `to` currency === fx.base, return the basic inverse rate of the `from` currency
  if (to === base) {
    return 1 / rates[from];
  }

  // Otherwise, return the `to` rate multipled by the inverse of the `from` rate to get the
  // relative exchange rate between the two currencies
  return rates[to] * (1 / rates[from]);
}
